<template>
  <div class="calendar-btn-selector-container">
    <div class="nav-button calendar-item">
      <div class="calendar-btn-top-area"> </div>
      <button class="btn" @click.prevent="moveDayBack">
        <i class="fal fa-angle-left"></i>
      </button>
    </div>
    <div class="calendar-btn-selector-list">
      <template v-for="dayInfo in dayList">
        <div class="calendar-item calendar-day" :key="dayInfo.id">
          <div class="calendar-btn-top-area calendar-btn-selector-month">{{dayInfo.monthGroupTitle}}</div>
          <button :class="{'btn': true, 'day-today': dayInfo.isToday, 'day-selected': dayInfo.isSelected}" @click.prevent="selectCurrentDay(dayInfo.date)">
            <div class="day-number">{{dayInfo.number}}</div>
            <div class="day-name">{{dayInfo.day}}</div>
            <div class="day-task-marker" v-if="dayInfo.hasTasks"></div>
          </button>
        </div>
      </template>
    </div>
    <div class="nav-button calendar-item">
      <div class="calendar-btn-top-area"> </div>
      <button class="btn" @click.prevent="moveDayForward">
        <i class="fal fa-angle-right"></i>
      </button>
    </div>
  </div>
</template>


<script>
import moment from 'moment'

export default {
  name: 'CalendarDaySelector',
  props: {
    value: Date,
    eventsList: Array     // In FullCalendar events format
  },
  data() {
    return {
      offsetDate: moment(this.value).local().subtract(5, 'days').toDate(),       // Give a few days spacer so the current date is near the start/middle point
      dayList: []
    }
  },
  watch: {
    value: function() {
      let curDate = moment(this.value).local()

      // Recalculate offset if the date has changed too much
      let offsetDiff = curDate.diff(this.offsetDate, 'days')
      if(offsetDiff > 10)
        this.offsetDate = moment(this.value).local().subtract(10, 'days').toDate()
      else if(offsetDiff < 0)
        this.offsetDate = moment(this.value).local().subtract(1, 'days').toDate()

      this.recalculateDayList()
    },
    eventsList: function() {
      this.recalculateDayList()
    }
  },
  mounted() {
    this.recalculateDayList()
  },
  methods: {
    selectCurrentDay(date) {
      this.$emit('input', moment(date).toDate())
    },
    moveDayBack() {
      this.selectCurrentDay(moment(this.value).local().subtract(1, 'day'))
    },
    moveDayForward() {
      this.selectCurrentDay(moment(this.value).local().add(1, 'day'))
    },
    recalculateDayList() {
      var outputDayList = []
      var maxDays = 31
      var curDay = moment(this.offsetDate).local().startOf()
      var prevMonth = null

      for(var i=0; i<maxDays; i++) {
        var dayMonth = curDay.format('MMMM').toUpperCase()

        var hasTasks = false
        if(this.eventsList) {
          if(this.eventsList.find(event => curDay.isSame(moment(event.start).local(), 'day')) != null)
            hasTasks = true
        }

        outputDayList.push({
          id: curDay.unix(),
          date: curDay.toDate(),
          isSelected: curDay.isSame(moment(this.value).local(), 'day'),
          isToday: curDay.isSame(moment().local(), 'day'),
          number: curDay.format('D'),
          day: curDay.format('ddd').toUpperCase(),
          month: curDay.format('MMMM').toUpperCase(),
          monthGroupTitle: prevMonth != dayMonth ? dayMonth : '',
          hasTasks: hasTasks
        })
        curDay = curDay.add(1, 'day')
        prevMonth = dayMonth
      }
      this.dayList = outputDayList
    }
  }
}
</script>